/* eslint-disable max-len */
import React from 'react';
import './help.css';
import logo from './athenahealth.png';

import Collapisble from '../components/Collapsible';
import Title from '../components/Title';
export default function AthenanetHelpTemplate() {

  React.useEffect(() => {
    document.title = 'Help - Login with athenahealth';
  }, []);

  return (
    <Title>
      <React.Fragment>
        <div className="help-header">
          <div className="logo">
            <img className="img-logo" alt="athenahealth" src={logo}/>
          </div>
        </div>
        <div className="help-body">
          {/* <!--Login in -->*/}
          <Collapisble content={<div>
            <h3>What credentials do I use to log in?</h3>
            <p>Please enter the same username and password you use to access athenaOne. Your username is not an email address and is typically comprised of your first initial and last name.</p>

            <h3>I forgot my password. How do I reset it?</h3>
            <p>If you don&apos;t know your password, click on <a href="https://athenanet.athenahealth.com/1/1/resetpassword.esp?LOGINURL=We">this link</a> and follow the instructions to reset it. If you are still unable to log in, please contact an athenaOne superuser at your organization to assist you.</p>
          </div>
          }
          header={'Logging in'}
          headerId={'default'}
          ></Collapisble>
        </div>
      </React.Fragment>
    </Title>
  );
}

